import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { Button } from 'angieslist-react-components';
import { Track, urlCatalog } from 'angieslist-app-platform';
import * as authActions from 'angieslist-app-platform/lib/common/auth/authActions';
import './userFlyout.scss';

const UserFlyout = ({
  logout, iconStyle, user,
}) => {
  const userId = get(user, 'userInfo.response.userId');
  return (
    <div id="auth-header--flyout-icon" key="user" className="flyout-menu">
      <Track>
        <a
          id="auth-header--user-flyout--account-icon-link"
          href={urlCatalog.office.account.home()}
          data-track-description="Manage Account User Name"
          className="main-menu-row-element"
          aria-label="View My Account"
          role="button"
        >
          <i className="icon icon-ellipse" style={iconStyle} />
        </a>
      </Track>
      <div className="flyout-menu__content" id="auth-header--flyout-menu">
        <ul className="main-menu-user-list">
          <li key="auth-header--account-contact-preferences" id="auth-header--user-flyout--contact-preferences">
            <i className="icon icon-add-review icon-lg" />
            <Track>
              <a id="auth-header--user-flyout--personal-settings-link" data-track-description="Personal settings" href={urlCatalog.office.account.contactPreferences()}>Personal settings</a>
            </Track>
          </li>
        </ul>
        <Track>
          <Button
            id="auth-header--user-flyout--sign-out-link"
            bsStyle="primary-office"
            bsSize="small"
            data-track-description="Sign Out"
            block
            flat
            onClick={() => logout(userId)}
          >SIGN OUT
          </Button>
        </Track>
      </div>
    </div>
  );
};

UserFlyout.propTypes = {
  logout: PropTypes.func.isRequired,
  iconStyle: PropTypes.object,
  user: PropTypes.object.isRequired,
};

export default compose(
  connect(
    state => ({
      browser: state.browser,
      user: state.user,
    }),
    { ...authActions },
  ),
  pure,
)(UserFlyout);



// WEBPACK FOOTER //
// ./src/app/browser/header/UserFlyout.js